module.exports = __webpack_public_path__ + "static/media/05.02377809.jpg";